import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/news',
    name: 'News',
    component: () => import('../views/news/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/users/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/express-companies',
    redirect: '/settings/express-companies'
  },
  {
    path: '/settings/express-companies',
    name: 'ExpressCompaniesMain',
    component: () => import('../views/settings/express-companies.vue'),
    meta: { requiresAuth: true }
  },

  {
    path: '/roles',
    name: 'Roles',
    component: () => import('../views/roles/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles/add',
    name: 'RoleAdd',
    component: () => import('../views/roles/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/roles/edit/:id',
    name: 'RoleEdit',
    component: () => import('../views/roles/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins',
    name: 'Admins',
    component: () => import('../views/admins/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins/add',
    name: 'AdminAdd',
    component: () => import('../views/admins/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admins/edit/:id',
    name: 'AdminEdit',
    component: () => import('../views/admins/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/add',
    name: 'NewsAdd',
    component: () => import('../views/news/add.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/news/edit/:id',
    name: 'NewsEdit',
    component: () => import('../views/news/edit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/products/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/orders/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/pending',
    name: 'PendingOrders',
    component: () => import('../views/orders/pending.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/processing',
    name: 'ProcessingOrders',
    component: () => import('../views/orders/processing.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/completed',
    name: 'CompletedOrders',
    component: () => import('../views/orders/completed.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/shipped',
    name: 'ShippedOrders',
    component: () => import('../views/orders/shipped.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/orders/paid-deposit',
    name: 'PaidDepositOrders',
    component: () => import('../views/orders/paid-deposit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/product-types',
    name: 'ProductTypes',
    component: () => import('../views/products/types.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/settings/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/express-companies',
    name: 'SettingsExpressCompanies',
    component: () => import('../views/settings/express-companies.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings/platforms',
    name: 'SettingsPlatforms',
    component: () => import('../views/settings/platforms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () => import('../views/permissions/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/permissions/manage/:id',
    name: 'PermissionManage',
    component: () => import('../views/permissions/manage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/finance/income',
    name: 'FinanceIncome',
    component: () => import('../views/finance/income.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/finance/reports',
    name: 'FinanceReports',
    component: () => import('../views/finance/reports.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory',
    name: 'InventoryManagement',
    component: () => import('../views/inventory/index.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory/warning',
    name: 'InventoryWarning',
    component: () => import('../views/inventory/warning.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory/in',
    name: 'InventoryIn',
    component: () => import('../views/inventory/in.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory/out',
    name: 'InventoryOut',
    component: () => import('../views/inventory/out.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customer-profile',
    name: 'CustomerProfile',
    component: () => import('../views/CustomerProfile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/image-upload',
    name: 'ImageUpload',
    component: () => import('../views/ImageUpload.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  // 如果访问登录页面
  if (to.path === '/login') {
    if (token) {
      // 已登录用户访问登录页，跳转到首页
      next('/')
    } else {
      // 未登录用户，允许访问登录页
      next()
    }
    return
  }
  
  // 如果访问需要认证的页面
  if (to.meta.requiresAuth) {
    if (!token) {
      // 需要登录但没有token，跳转到登录页
      next('/login')
    } else {
      // 有token，允许访问
      next()
    }
    return
  }
  
  // 其他情况，允许访问
  next()
})

export default router